import { PlusIcon } from '..';
import AGButton from '../../../components/Button';
import PDFPreviewFirstPage from '../../../components/PDFPreviewFirstPage';
import { RolesHandle } from '../../../components/RolesHandle';
import { API_CONSTANT } from '../../../utils/constant';
import { BrochureProps } from './brochure.props';
import { Div } from './brochure.styled';


const BrochureItem = ({ bodyContent, data, isService, onAdd, servicePdf }: BrochureProps) => {
    const apiDomain = process.env.REACT_APP_API_DOMAIN

    const downloadAttachment = async (path: string) => {
        try {
            const response = await fetch(`${apiDomain}/download/${path}`, {
                method: 'GET',
                headers: {
                    // Optionally, add any required headers here
                }
            });

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = path;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    return (
        <>
            {data?.brochurePath && (
                <Div className="description w-full">
                    <PDFPreviewFirstPage pdfUrl={`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.PDF}${data.brochurePath}`} />
                    <Div className='view-pdf w-full'>
                        <AGButton
                            className='view-pdf-btn'
                            type={'Link'}
                            onClick={() => {
                                window.open(`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.PDF}${data.brochurePath}`, '_blank');
                                // downloadAttachment(data.brochurePath!);
                            }}>
                            View PDF
                        </AGButton>
                    </Div>
                </Div>
            )}
            {
                !data?.brochurePath &&
                <RolesHandle
                    firmId={data?.fkFirmId!}
                    roles={['Admin']}>
                    <Div className='btn-add-new'>
                        <AGButton
                            type={'Link'}
                            icon={<PlusIcon />}
                            onClick={onAdd}>
                            {bodyContent}
                        </AGButton>
                    </Div>
                </RolesHandle>
            }
        </>
    )
}

export default BrochureItem;